// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVolumeHigh } from "@fortawesome/free-solid-svg-icons";
import { speakJapanese, isSpeechSupported, hasOfflineJapaneseVoice, SLOW_SPEECH_RATE } from "../../utils/speak";
import { useOnline } from "../../hooks/useOnline";
import SlowTurtleIcon from "./SlowTurtleIcon";
import styles from "./speakButton.module.scss";
import { useTranslation } from "react-i18next";

const speechSupported = isSpeechSupported();

// Set slow to render a "listen slowly" variant instead - same control, just
// played back at SLOW_SPEECH_RATE with a distinct icon/label/color, so a
// learner can request either speed wherever a normal SpeakButton appears.
function SpeakButton({ text, label, className, onPlay, onPlaybackError, slow = false }) {
    const online = useOnline();
    const [, setVoices] = useState(0);
    useEffect(() => {
        if (online || !speechSupported) return;
        const update = () => setVoices(value => value + 1);
        window.speechSynthesis?.addEventListener?.("voiceschanged", update);
        return () => window.speechSynthesis?.removeEventListener?.("voiceschanged", update);
    }, [online]);
    const blocked = !online && !hasOfflineJapaneseVoice();
    const { t } = useTranslation("common");
    if (!speechSupported || !text) return null;
    const buttonClassName = [styles.speakButton, slow && styles.speakButtonSlow, className].filter(Boolean).join(" ");
    return (
        <button
            type="button"
            disabled={blocked}
            title={blocked ? t("offline.voice") : undefined}
            className={buttonClassName}
            aria-label={label || t(slow ? "speakButton.playSlow" : "speakButton.play", { text })}
            onClick={() => {
                const options = slow ? { rate: SLOW_SPEECH_RATE } : undefined;
                const playbackOptions = onPlaybackError ? { ...(options || {}), onError: onPlaybackError } : options;
                if (speakJapanese(text, playbackOptions) !== false) onPlay?.();
                else onPlaybackError?.();
            }}
        >
            {slow ? <SlowTurtleIcon /> : <FontAwesomeIcon icon={faVolumeHigh} />}
        </button>
    );
}

export default SpeakButton;
